var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotationSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.69025 13.425C3.6575 12.9408 2.76896 12.1977 2.11181 11.2685C1.45465 10.3393 1.05147 9.25608 0.941817 8.125H0C0.320218 11.975 3.55379 15 7.50314 15L7.91754 14.9812L5.52532 12.6L4.69025 13.425ZM7.50314 0L7.08874 0.01875L9.48095 2.4L10.316 1.56875C12.3692 2.5375 13.8384 4.51875 14.0582 6.86875H15C14.6861 3.025 11.4525 0 7.50314 0Z",
    fill: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotationSmall);
export default __webpack_public_path__ + "static/media/rotation-small.ddd6effe723ef5014f6bf11a8f8add99.svg";
export { ForwardRef as ReactComponent };